import api from "../../../api/axios";

export const USER_DIRECTORY_PAGE_SIZE = 20;

export const fetchUsersDirectory = (params = {}, { signal } = {}) =>
  api.get("/users/", { params, signal }).then((res) => res.data);

export function isRequestAbortError(error) {
  if (!error) return false;
  if (error.name === "AbortError" || error.name === "CanceledError") return true;
  if (error.code === "ERR_CANCELED") return true;
  return false;
}
